import hres78uLabels from 'assets/labels/hres78u'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres78uLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockRows.push({
        id: i,
        approvno: faker.random.number().toString().substr(0, 1),
        chk_appr: '',
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        dtereq: moment().format('DD/MM/YYYY'),
        numseq: faker.random.number().toString().substr(0, 1),
        typeloan: faker.random.words(),
        amtlonreq: faker.commerce.price(),
        codcurr: 'บาท',
        numlonreq: faker.random.number().toString().substr(0, 2) + '/' + faker.random.number().toString().substr(0, 1),
        numcont: faker.random.number(),
        amtlon: faker.commerce.price(),
        numlon: faker.random.number().toString().substr(0, 2) + '/' + faker.random.number().toString().substr(0, 1),
        desc_codappr: faker.name.findName(),
        dteappr: moment().format('DD/MM/YYYY'),
        remark: faker.lorem.words(),
        desc_codempap: faker.name.findName(),
        codlon: '',
        staappr: '',
        status: mockStatus[staappr]
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY'),
      desc_codlon: faker.random.words(),
      amtlonreq: faker.commerce.price(),
      numlonreqyr: faker.random.number().toString().substr(0, 1),
      numlonreqmth: faker.random.number().toString().substr(0, 1),
      reaslon: 'ขอกู้เงิน',
      qtyperiod: faker.random.number().toString().substr(0, 2),
      amttlpay: faker.commerce.price(),
      amtpaybo: faker.commerce.price()
    }
    let mockTab2 = {
      desc_codlon: faker.random.words(),
      amtmxlon: faker.commerce.price(),
      ratelon: '0',
      nummxlonyr: faker.random.number().toString().substr(0, 1),
      nummxlonmth: '0',
      remark: faker.random.words()
    }
    let mockTab3Rows = []
    const mockTab3Total = 5
    for (var i = 1; i <= mockTab3Total; i++) {
      mockTab3Rows.push({
        id: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        numcont: faker.random.number(),
        dtelonst: moment().format('DD/MM/YYYY'),
        amtlon: faker.commerce.price(),
        amtnpfin: faker.commerce.price(),
        dteaccls: moment().format('DD/MM/YYYY'),
        desc_codlon: faker.random.words(),
        numlon: faker.random.number().toString().substr(0, 2) + '/' + faker.random.number().toString().substr(0, 1)
      })
    }

    return {
      tab1: mockTab1,
      tab2: mockTab2,
      tab3: {
        table: {
          total: mockTab3Total,
          rows: mockTab3Rows
        }
      }
    }
  },
  detailSubmit () {
    let mockTab1 = {
      staappr: '',
      flgStaappr: '',
      approvno: '1',
      chk_appr: '',
      numseq: '1',
      dtereq: moment().format('DD/MM/YYYY'),
      codempid: faker.lorem.word(),
      desc_codempid: faker.lorem.words(),
      codappr: faker.lorem.word(),
      desc_codappr: faker.lorem.word(),
      dteappr: moment().format('DD/MM/YYYY'),
      numcont: faker.random.number(),
      dtelonst: moment().format('DD/MM/YYYY'),
      amtlon: faker.commerce.price(),
      numlonreqyr: faker.random.number().toString().substr(0, 1),
      numlonreqmth: faker.random.number().toString().substr(0, 1),
      typintr: '3',
      rateilon1: faker.commerce.price(),
      rateilon3: faker.commerce.price(),
      rateilon4: faker.commerce.price(),
      status: faker.lorem.words(),
      codlon: faker.lorem.words(),
      remark: faker.lorem.words(),
      flgwarn: ''
    }
    return {
      tab1: mockTab1
    }
  },
  dropdowns () {
    const mockTypintr = {
      '1': '1 - อัตราตามวงเงิน',
      '2': '2 - กำหนดอัตราเอง',
      '3': '3 - อัตราสูงสุด',
      '4': '4 - อัตราคงที่'
    }

    return {
      typintr: {
        en: mockTypintr,
        th: mockTypintr
      }
    }
  },
  trailRepayment () {
    return {
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      codlon: '01',
      desc_codlon: 'กู้เพื่อที่อยู่อาศัย',
      amtmxlon: faker.commerce.price(),
      amtlon: faker.commerce.price(),
      numlonreqyr: faker.random.number().toString().substr(0, 1),
      numlonreqmth: faker.random.number().toString().substr(0, 1),
      typintr: '1',
      rateilon: faker.commerce.price(),
      monthst: moment().format('MM'),
      yearst: moment().format('YYYY'),
      typlonpay: '1',
      qtyperiod: '0',
      amtlpay: faker.commerce.price(),
      mthbon1: moment().format('MM'),
      mthbon2: moment().format('MM'),
      ratebon: faker.commerce.price(),
      amtpnor: faker.commerce.price(),
      amtpbon: faker.commerce.price(),
      pctsalbo: faker.commerce.price()
    }
  },
  tableProcess () {
    let mockTableRows = []
    const mockTableTotal = 5
    for (var i = 1; i <= mockTableTotal; i++) {
      mockTableRows.push({
        periodd: i,
        mthyre: moment().format('MM/YYYY'),
        balancd: faker.commerce.price(),
        amtpfind: faker.commerce.price(),
        amtpintd: faker.commerce.price(),
        amtrepmtd: faker.commerce.price(),
        amtlpay: faker.commerce.price(),
        pctsalbo: faker.commerce.price(),
        amtpnor: faker.commerce.price(),
        amtpbon: faker.commerce.price()
      })
    }

    return {
      total: mockTableTotal,
      rows: mockTableRows
    }
  },
  datapersonal () {
    return {
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      desc_staemp: 'ปัจจุบัน',
      numlvl: faker.random.number().toString().substr(0, 2),
      dteempmt: moment().format('DD/MM/YYYY'),
      dteeffex: moment().format('DD/MM/YYYY'),
      serviceyr: faker.random.number().toString().substr(0, 1),
      servicemth: faker.random.number().toString().substr(0, 1),
      codpos: faker.lorem.word(),
      desc_codpos: faker.random.words(),
      codjob: faker.lorem.word(),
      desc_codjob: faker.random.words(),
      codcomp: faker.lorem.word(),
      desc_codcomp: faker.random.words(),
      codempmt: faker.lorem.word(),
      desc_codempmt: faker.random.words(),
      typemp: faker.lorem.word(),
      desc_typemp: faker.random.words(),
      typpayroll: faker.lorem.word(),
      desc_typpayroll: faker.random.words(),
      codcalen: faker.lorem.word(),
      desc_codcalen: faker.random.words(),
      codedlv: faker.lorem.word(),
      desc_codedlv: faker.random.words(),
      amtincom1: faker.commerce.price()
    }
  },
  approve () {
    return {
      codempid: faker.lorem.word(),
      desc_codempid: faker.lorem.words(),
      codappr: faker.lorem.word(),
      desc_codappr: faker.lorem.word(),
      dteappr: moment().format('DD/MM/YYYY'),
      numcont: faker.random.number(),
      dtelonst: moment().format('DD/MM/YYYY'),
      amtlon: faker.commerce.price(),
      numlonreqyr: faker.random.number().toString().substr(0, 1),
      numlonreqmth: faker.random.number().toString().substr(0, 1),
      typintr: '',
      rateilon: faker.commerce.price(),
      status: faker.lorem.words(),
      remark: faker.lorem.words(),
      staappr: ''
    }
  },
  sendApprove () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres78u/mocker.js